import { creatImageUrlFromName } from "./image.utils";
import { log } from "./server-log";

export const onDelete = (cart) => (artnr) => {
    cart.delete(artnr);
};

export const onNumChange = (cart) => (artnr, sample, newNum) => {
    if (newNum < 1) {
        return onDelete(cart)(artnr);
    }
    cart.updateNumItems(artnr, sample, newNum);
};

/**
 *
 * @param {string} code
 * @returns {Promise<import("../lib/discounts/types").Discount | null>}
 */
export const loadDiscountInfo = async (code) => {
    if (!code) {
        return null;
    }
    try {
        const res = await fetch(`/server-api/discount?code=${code}`);
        if (res.status === 200) {
            /** @type {import("$lib/discounts/types").Discount} */
            const discount = await res.json();
            return discount;
        }
    } catch (e) {
        log(`Discount code "${code}" couldn't be loaded: `, e instanceof Error ? e.message : "Unkown error");
    }
    return null;
};

export const generateProductSizeString = (cartProduct) => {
    return cartProduct.sizes[0].name;
};

export const getImageUrl = (product) => {
    if (product.displayImage && product.displayImage.name) {
        return creatImageUrlFromName(product.displayImage.name, 4);
    }
    if (product.colors.length && product.colors[0].image) {
        return creatImageUrlFromName(product.colors[0].image.name, 4);
    }
    if (product.images && product.images.length && product.images[0].name) {
        return creatImageUrlFromName(product.images[0].name, 4);
    }
    return "/images/empty-product-image.png";
};

/** @param {import("../routes/server-api/product/types").Size} size */
export function getStockText(size) {
    if (size.stock && !size.stock.inStock) {
        if (size.stock.discontinued) {
            return "Denna storlek/färg har tyvärr utgått";
        }
        return `Tillfälligt slut, inkommer ${size.stock.backInStock}`;
    }
    return "";
}
